/**
 * Client-side file download helpers, shared by everything that writes a task
 * list back out in the "task name - estimate - link - assignee" import format:
 * the admin's task-proposal review popup and the selected-task export on
 * SheetDetail. There's no endpoint behind either one — the file is built in the
 * browser from data the page already has, and pasting it into ImportTasksModal
 * anywhere is what completes the round trip.
 */

/** Filesystem-safe-ish filename piece. */
export const slug = (s) => (s || "").trim().replace(/[\\/:*?"<>|]+/g, "-").replace(/\s+/g, " ");

/** Hands the browser a text file without a round trip to the server. */
export function downloadText(filename, text) {
  const url = URL.createObjectURL(new Blob([text], { type: "text/plain;charset=utf-8" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
